import { PresetType } from '@/utils';
import { Tooltip } from '@reach/tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import { IconButton } from '@/components/atom';
import styles from './presetEntry.module.less';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class PresetEntry extends React.PureComponent {
  static get propTypes() {
    return {
      id: PropTypes.string.isRequired,
      preset: PresetType,
      onClick: PropTypes.func,
      renamePreset: PropTypes.func,
      copyPreset: PropTypes.func,
      deletePreset: PropTypes.func,
      alertSuccess: PropTypes.func,
      showConfirmModal: PropTypes.func
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      editable: false,
      name: props.preset.name
    };
  }
  render() {
    const {
      editable: presetEditable
    } = this.props.preset;
    const {
      editable
    } = this.state;
    return /*#__PURE__*/_jsx("div", {
      onClick: e => this.onClick(e),
      className: styles.wrapper,
      children: editable && presetEditable ? this._renderForm() : this._renderPreset()
    });
  }
  _renderPreset() {
    const {
      name,
      editable,
      selected
    } = this.props.preset;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [selected ? /*#__PURE__*/_jsx("strong", {
        children: name
      }) : /*#__PURE__*/_jsx("span", {
        children: name
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.actions,
        children: [/*#__PURE__*/_jsx(Tooltip, {
          label: "Duplicate preset",
          children: /*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(IconButton, {
              onClick: e => this.onCopy(e),
              name: "copy"
            })
          })
        }), editable && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Tooltip, {
            label: "Edit preset",
            children: /*#__PURE__*/_jsx("span", {
              children: /*#__PURE__*/_jsx(IconButton, {
                onClick: e => this.onEdit(e),
                name: "edit"
              })
            })
          }), /*#__PURE__*/_jsx(Tooltip, {
            label: "Delete preset",
            children: /*#__PURE__*/_jsx("span", {
              children: /*#__PURE__*/_jsx(IconButton, {
                onClick: e => this.onDelete(e),
                name: "trash"
              })
            })
          })]
        })]
      })]
    });
  }
  _renderForm() {
    const {
      name
    } = this.state;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("input", {
        onChange: e => this.onChange(e),
        value: name,
        type: "text"
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.actions,
        children: [/*#__PURE__*/_jsx(Tooltip, {
          label: "Confirm changes",
          children: /*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(IconButton, {
              onClick: e => this.onConfirm(e),
              color: "success",
              name: "check"
            })
          })
        }), /*#__PURE__*/_jsx(Tooltip, {
          label: "Discard changes",
          children: /*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(IconButton, {
              onClick: e => this.onDiscard(e),
              color: "danger",
              name: "close"
            })
          })
        })]
      })]
    });
  }
  onChange({
    target: {
      value
    }
  }) {
    this.setState({
      name: value
    });
  }
  onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    const {
      onClick
    } = this.props;
    const {
      editable
    } = this.state;
    if (editable) {
      return;
    }
    onClick();
  }
  onConfirm(e) {
    e.preventDefault();
    e.stopPropagation();
    const {
      name
    } = this.state;
    const {
      renamePreset,
      id
    } = this.props;
    renamePreset({
      id,
      name
    });
    this.setState({
      editable: false
    });
  }
  onCopy(e) {
    e.preventDefault();
    e.stopPropagation();
    const {
      copyPreset,
      id
    } = this.props;
    copyPreset(id);
  }
  onEdit(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      editable: true
    });
  }
  onDelete(e) {
    e.preventDefault();
    e.stopPropagation();
    const {
      name
    } = this.props.preset;
    const {
      showConfirmModal,
      deletePreset,
      id,
      alertSuccess
    } = this.props;
    showConfirmModal({
      body: /*#__PURE__*/_jsxs("p", {
        children: ["Are you sure you ", /*#__PURE__*/_jsx("strong", {
          children: "want to delete"
        }), " ' ", name, "' preset?"]
      }),
      accept: () => {
        deletePreset(id);
        alertSuccess(`Preset '${name}' was deleted.`);
      }
    });
  }
  onDiscard(e) {
    e.preventDefault();
    e.stopPropagation();
    const {
      name
    } = this.props.preset;
    this.setState({
      name,
      editable: false
    });
  }
}